<template>
    <div class="cb-wizard-step4 cb-wizard__container">
        <div class="cb-wizard__body">
            <div class="cb-wizard__header">
                <h3 class="cb-wizard__title">Strategy notes</h3>
                <Stepper class="cb-wizard__stepper"
                    :labels="['Step1', 'Step2', 'Step3', 'Step4', 'Step5']"
                    :currentStep="3" />
            </div>
            <div class="cb-wizard-step4__body">
                <Editor
                    class="cb-wizard-step4__editor"
                    v-model="strategyNotes"
                    :init="{
                      verify_html: false,
                      selector: 'textarea',
                      menubar: false,
                      statusbar: false,
                      plugins: 'advlist code autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount textcolor colorpicker hr',
                      toolbar: 'formatselect forecolor backcolor bold italic link bullist numlist image table code undo redo removeformat hr',
                      height: '350px',
                      invalid_elements: 'style,script',
                      setup: function (editor) {
                        tinyMCE = editor
                        editor.on('init', () => {
                          initialOptimizedContent = editor.getContent();
                        })
                      }
                    }"
                  />
            </div>
        </div>
        <div class="cb-wizard__sidebar">
            <span class="cb-wizard__sidebar-title">Write Some Prewriting Strategy Notes</span>
            <p class="cb-wizard__sidebar-text">The strategy notes area of the content brief serves as a place to share and collaborate ideas, outlines, references, or whatever is helpful to informing contributors of your content process.</p>
            <p class="cb-wizard__sidebar-text">You can write notes now, or revisit and update the strategy notes section at anytime in the future.</p>
            <div class="cb-wizard__controls">
                <button class="cb-wizard__button"
                    @click="next">Next</button>
                <button class="cb-wizard__button cb-wizard__button_inverted"
                    @click="back">Previous</button>
            </div>
        </div>
    </div>
</template>

<script>
import Stepper from './stepper.vue';
import Editor from '@tinymce/tinymce-vue';

export default {
    name: 'ContentBriefWizardStep4',
    props: {
        notes: String
    },
    components: { Stepper, Editor },
    data() {
        return {
            strategyNotes: this.notes
        }
    },
    computed: {
        
    },
    methods: {
        next() {
            this.$emit('strategyNotesSet', this.strategyNotes);
        },
        back() {
            this.$emit('previous')
        }
    },

}
</script>